export enum Platforms {
   TWITTER = 'twitter',
   TELEGRAM = 'telegram',
   WHATSAPP = 'whatsapp',
   MESSAGE = 'message',
   MORE = 'more',
}
